// Array of slider configurations with container and controls selectors
var sliderConfigs = [
	{
	container: ".slider-infFeaturesLg",
	controls: ".slider-infFeaturesLg-controls"
	},
	{
	container: ".slider-infFeatures-pc",
	controls: ".slider-infFeatures-pc-controls"
	},
	{
	container: ".slider-infFeatures-mac",
	controls: ".slider-infFeatures-mac-controls"
	},
	{
	container: ".slider-infFeatures-android",
	controls: ".slider-infFeatures-android-controls"
	}
];

// A helper function to initialize a single slider
function initSlider(container, controlsContainer) {
// Create the slider using the tiny-slider (tns) function
var slider = tns({
	container: container,
	controlsContainer: controlsContainer,
	preventScrollOnTouch: "force",
	controlsPosition: "bottom",
	navPosition: "bottom",
	gutter: 24,
	slideBy: "page",
	responsive: {
	768: {
		items: 2
	},
	992: {
		items: 1,
		gutter: 32
	},
	1280: {
		items: 2
	}
	}
});

// Required module to create a slide counter on mobile
avm.require("avast.web.slideCounter")(slider);

return slider;
}

// Initialize sliders for all configurations in the array
sliderConfigs.forEach(function (config) {
initSlider(config.container, config.controls);
});